import { render, staticRenderFns } from "./AddLabourerPaymentPage.vue?vue&type=template&id=1f258562&scoped=true&"
import script from "./AddLabourerPaymentPage.vue?vue&type=script&setup=true&lang=js&"
export * from "./AddLabourerPaymentPage.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f258562",
  null
  
)

export default component.exports